// Resolves the deployed travel-search host (used for both the API and the micro-frontend bundle).
export function getTravelSearchHost(environment: string): string {
  if (!environment) {
    throw new Error('Could not resolve travel search host: environment is not set')
  }

  let _environment: string
  if (environment === 'prod') {
    _environment = 'prod'
  } else if (environment === 'test') {
    _environment = 'test'
  } else if (environment === 'uat') {
    _environment = 'uat'
  } else if (environment === 'dev' || environment === 'localhost') {
    _environment = 'dev'
  } else {
    throw new Error(`Could not resolve travel search host for environment: ${environment}`)
  }

  return `https://travel-search-${_environment}.dfds-pax-web.com`
}
